<template>
  <div class="home-page">
    <div class="header-bgfff bgfff">
      <Header></Header>
      <div class="nav ac">
        <div class="back" @click="back">
          <img width="40" src="../../static/images/back2.png" />
        </div>
        <span>
        {{info.task_name_text}}
        </span>
      </div>
    </div>

    <main class="home-content learning-content" v-if="infoStudy.length > 0 && !isTest">
      <div class="character-section mt20 disflex">
        <div>
          <div class="character-row disflex ac" :class="{ 'image-grow': activeAudio === 'word' }"  style="justify-content: center;">
            <span class="pinyin">{{infoStudy[study_num].word.contentPhonetic}}</span>
            <span class="checkmark" @click="playSingleAudio('word')">
              <img src="../../static/images/yin.png" />
            </span>
            <audio
              ref="audioWord"
              :src="infoStudy[study_num].word.audioUrl"
              playsinline
              webkit-playsinline
              style="display: none;"
            ></audio>
          </div>

          <div class="character-display" v-html="infoStudy[study_num].word.cardContent"></div>
        </div>
        <div>
          <div class="character-row ac">
            <span class="pinyin">{{pinyinNumberToTone(infoStudy[study_num].words.contentPhonetic)}}</span>
          </div>
          <div class="character-words disflex">
            <div class="disflex" style="justify-content: center;" :class="{ 'image-grow': activeAudio === 'words' }">
              <span class="hanzi" v-html="infoStudy[study_num].words.cardContent"></span>
              <span class="checkmark" @click="playSingleAudio('words')">
                <img src="../../static/images/yin.png" />
              </span>
              <audio
                ref="audioWords"
                :src="infoStudy[study_num].words.audioUrl"
                playsinline
                webkit-playsinline
                style="display: none;"
              ></audio>
            </div>
          </div>
        </div>
      </div>
      <div class="divider ac mt50">
        <img @click="initAudioPlayback" src="../../static/images/repeat.png">
      </div>
      <div class="sample-sentence mt50 ac">
        <h2>{{$t('Sample Sentence')}}</h2>
        <div class="bgbr sentence-content fs27 mt20 cr2a2d5a">
          <p class="chinese-sentence disflex" :class="{ 'image-grow': activeAudio === 'sentence' }">
            <span v-html="infoStudy[study_num].sentence.cardContent"></span>
            <span @click="playSingleAudio('sentence')">
              <img src="../../static/images/yin.png" />
            </span>
          </p>
          <audio
            ref="audioSentence"
            :src="infoStudy[study_num].sentence.audioUrl"
            playsinline
            webkit-playsinline
            style="display: none;"
          ></audio>
          <p class="english-translation fw7">{{infoStudy[study_num].sentence.content}}</p>
        </div>
      </div>
      <footer class="navigation disflex mt50">
        <button
          class="button pre-button font-family"
          @click="Previous"
          :disabled="study_num === 0"
        >{{$t('Previous')}}</button>
        <button
          class="button next-button font-family"
          @click="Next"
          :disabled="study_num === study_num_all"
        >{{$t('Next')}}</button>
      </footer>
      <div class="progress fw7 fs27 mt50 ac">{{ study_num + 1 }} of {{ study_num_all }}</div>
    </main>
    <main class="home-content learning-content" v-if="isTest">
      <h2 class="ac mt30 font-family">{{infoTest[test_num].title}}</h2>
      <div class="ciyu disflex mt50" style="justify-content: space-around;" v-if="infoTest[test_num].questionType==1">
        <div class="ciyu-li" :class="{'wenhao':item==''}" v-for="(item,index) in infoTest[test_num].questionContent">
          {{item}}
        </div>
      </div>
      <div class="ciyu disflex mt50" v-if="infoTest[test_num].questionType==2">
        <img style="width:100%" :src="infoTest[test_num].resUrl" />
      </div>
      <div class="ciyu disflex mt50" v-if="infoTest[test_num].questionType==3">
        <span class="" @click="playAudio('audioAnswer')" :class="{ 'image-grow': activeAudio2 === 'audioAnswer' }"  style="justify-content: center;">
          <img style="width:200px;border-radius: 60px;" src="../../static/images/ting.png" />
        </span>
        <audio
          ref="audioAnswer"
          :src="infoTest[test_num].resUrl"
          playsinline
          webkit-playsinline
          style="display: none;"
        ></audio>
      </div>
      <div class="test-answerList disflex mt50">
        <div class="ans-li" v-for="(item,index) in infoTest[test_num].answerList" @click="getNextAnswer(item)">
          <div class="character-display">{{item.answerContent}}</div>
          <div class="ans-sb" v-if="showFeedback && isActive==item.id">
            <img :src="isDui?'../../static/images/dui.png':'../../static/images/cuo.png'">
          </div>
        </div>
      </div>
      <div class="progress fw7 fs27 mt50 ac">{{ test_num + 1 }} of {{ test_num_all }}</div>
    </main>
  </div>
</template>

<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
  components: {
    Header,
    Dialog
  },
  data() {
    return {
      isShow: null,
      info: {},
      infoStudy: [],
      infoTest: [],
      questionList: [],
      study_num: 0,
      test_num: 0,
      id: {},
      gameList: null,
      isFirstLoad: true,
      study_num_all: 0,
      test_num_all: 0,
      activeAudio: null,
      activeAudio2:null,
      isDui:'',
      isActive:'',
      question_id:'',
      isTest:false,
      showFeedback: false,

    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$parent) {
      this.$parent.bgmEnabled = true;        // 允许播放
    }
    next();  // 继续导航
  },
  created() {
    // 暂停背景音乐
    if (this.$parent && this.$parent.stopBackgroundMusic) {
      this.$parent.stopBackgroundMusic(true);
      this.$parent.bgmEnabled = false;
    }
    this.id = this.$route.query.id
    this.getList();
  },
  mounted() {
    document.addEventListener('click', this.handleFirstInteraction, { once: true });
  },
  methods: {
    back(){
      this.$router.push({path:'/Challenge',query: {}});
    },
    playAudio(type){
      if (this.$refs.audioAnswer) {
        this.activeAudio2 = type;
        this.$refs.audioAnswer.pause();
        this.$refs.audioAnswer.currentTime = 0;
        this.$refs.audioAnswer.play().catch(e => console.log("播放失败:", e));
        this.$refs.audioAnswer.onended = () => {
          this.activeAudio2 = null;
        };
      }
    },
    getNextAnswer(item){
      let that = this
      that.isDui = null
      that.showFeedback = false
      if(that.question_id == item.question_id){
        return;
      }
      let data = {
        "question_id":item.question_id,
        "answer_id":item.id
      }
      that.question_id = item.question_id
      that.isActive = item.id

      that.$api.post('/api/task/submit_answer', data, r => {
        that.$parent.returnCode(r,function(){
          that.isDui = r.data.result
          that.showFeedback = true
          setTimeout(() => {
            if (that.test_num < that.test_num_all) {
              that.isDui = null
              that.isActive = ''
              that.question_id = ''
              that.showFeedback = false
              that.test_num++;
              if(that.test_num==6){
                that.$router.push({path:'/ChallengeResult',query:{id:that.$route.query.id}});
              }
              console.log(that.test_num)
              if(that.infoTest[that.test_num].questionType==3){
                that.playAudio('audioAnswer')
              }
            }
          }, 1000);
        })
      })
    },
    Next() {
      let that = this;
      if (this.study_num < this.study_num_all) {
        this.study_num++;
        if(that.study_num==6){
          setTimeout(() => {
            that.isTest = true
            if(that.infoTest[that.test_num].questionType==3){
              that.playAudio('audioAnswer')
              console.log(2233232432)
            }
          }, 1000);
          return;
        }
        this.$nextTick(() => {
          this.initAudioPlayback();
        });

      }
    },
    Previous() {
      if (this.study_num > 0) {
        this.study_num--;
        this.$nextTick(() => {
          this.initAudioPlayback();
        });
      }
    },
    handleFirstInteraction() {
      if (this.isFirstLoad && this.infoStudy.length > 0) {
        this.initAudioPlayback();
        this.isFirstLoad = false;
      }
    },
    playSingleAudio(type) {
      const audioRef = `audio${type.charAt(0).toUpperCase() + type.slice(1)}`;
      if (this.$refs[audioRef]) {
        this.pauseAllAudios();
        this.clearAudioEventListeners();
        this.activeAudio = type;
        this.$refs[audioRef].currentTime = 0;
        this.$refs[audioRef].play().catch(e => console.log("播放失败:", e));
        this.$refs[audioRef].onended = () => {
          this.activeAudio = null;
        };
      }
    },
    clearAudioEventListeners() {
      if (this.$refs.audioWord) this.$refs.audioWord.onended = null;
      if (this.$refs.audioWords) this.$refs.audioWords.onended = null;
      if (this.$refs.audioSentence) this.$refs.audioSentence.onended = null;
    },
    pauseAllAudios() {
      this.activeAudio = null;
      ['audioWord', 'audioWords', 'audioSentence'].forEach(ref => {
        if (this.$refs[ref]) {
          this.$refs[ref].pause();
          this.$refs[ref].currentTime = 0;
        }
      });
    },
    initAudioPlayback() {
      this.pauseAllAudios();
      this.setupSequentialPlayback();
      this.activeAudio = 'word';
      this.$nextTick(() => {
        if (this.$refs.audioWord) {
          this.$refs.audioWord.play().catch(e => console.log("自动播放被阻止"));
        }
      });
    },
    setupSequentialPlayback() {
      this.clearAudioEventListeners();
      if (this.$refs.audioWord) {
        this.$refs.audioWord.onended = () => {
          this.activeAudio = 'words';
          if (this.$refs.audioWords) {
            this.$refs.audioWords.play();
            this.$refs.audioWords.onended = () => {
              this.activeAudio = 'sentence';
              if (this.$refs.audioSentence) {
                this.$refs.audioSentence.play();
                this.$refs.audioSentence.onended = () => {
                  this.activeAudio = null;
                };
              }
            };
          }
        };
      }
    },
    playWordsAudio() {
      this.activeAudio = 'words';
      if (this.$refs.audioWords) {
        this.$refs.audioWords.play();
        this.$refs.audioWords.onended = () => {
          this.activeAudio = null;
        };
      }
    },
    playSentenceAudio() {
      this.activeAudio = 'sentence';
      if (this.$refs.audioSentence) {
        this.$refs.audioSentence.play();
        this.$refs.audioSentence.onended = () => {
          this.activeAudio = null;
        };
      }
    },
    pinyinNumberToTone(input) {
      input = input.replace(/([a-zA-ZüÜvV]+)[05](?!\d)/g, '$1');
      const toneMap = {
        a: ['ā','á','ǎ','à'],
        o: ['ō','ó','ǒ','ò'],
        e: ['ē','é','ě','è'],
        i: ['ī','í','ǐ','ì'],
        u: ['ū','ú','ǔ','ù'],
        v: ['ǖ','ǘ','ǚ','ǜ'],
        ü: ['ǖ','ǘ','ǚ','ǜ']
      };

      const normalizeUmlaut = s => s.replace(/u:/gi, m => (m[0] === 'U' ? 'Ü' : 'ü'));

      return normalizeUmlaut(input).replace(/([a-zA-ZüÜvV]+?)([1-5])(?![0-9])/g, (match, syl, tone) => {
        const t = parseInt(tone, 10);
        if (t === 5 || t === 0) return syl;

        const hasUpper = syl !== syl.toLowerCase();
        const lowerSyl = syl.toLowerCase().replace(/v/g, 'v').replace(/ü/g, 'ü');

        let main = -1;
        for (const v of ['a','o','e']) {
          const idx = lowerSyl.indexOf(v);
          if (idx !== -1) { main = idx; break; }
        }
        if (main === -1) {
          if (lowerSyl.includes('iu')) main = lowerSyl.indexOf('u');
          else if (lowerSyl.includes('ui')) main = lowerSyl.indexOf('i');
          else {
            for (const v of ['i','u','v','ü']) {
              const idx = lowerSyl.indexOf(v);
              if (idx !== -1) { main = idx; break; }
            }
          }
        }
        if (main === -1) return syl;

        const vowelOriginal = syl[main];
        const vowelLower = lowerSyl[main];
        const toneIdx = Math.max(0, Math.min(3, (t - 1)));
        let withTone = (toneMap[vowelLower] || [])[toneIdx];
        if (!withTone) return syl;
        if (vowelOriginal === vowelOriginal.toUpperCase()) withTone = withTone.toUpperCase();

        return syl.slice(0, main) + withTone + syl.slice(main + 1);
      });
    },
    getList() {
      let that = this
      let data = {
        "id": this.id
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/task/get_task_study', data, r => {
        that.$parent.returnCode(r,function(){
          that.info = r.data
          that.infoStudy = r.data.study || []
          that.infoTest = r.data.test || []
          that.study_num_all = r.data.study_num || 0
          that.test_num_all = r.data.test_num || 0
          that.$parent.loadModal(false);

          if (that.infoStudy.length > 0) {
            that.$nextTick(() => {
              that.initAudioPlayback();
            });
          }
          that.isFirstLoad = true;
        })
      })
    }
  }
}
</script>

<style scoped>
.checkmark {
  cursor: pointer;
  margin-left: 8px;
}
.checkmark img {
  width: 30px;
  height: 30px;
  vertical-align: middle;
  transition: transform 0.2s ease;
}
.divider {
  cursor: pointer;
}
.loading-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 18px;
}

.image-grow {
  animation: pulse 0.5s infinite alternate;
}
@keyframes pulse {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/page/ChallengeLearn.vue